import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { TableCell } from '@mui/material';
import { Search } from '@mui/icons-material';

import BoxGrid from '@/main/components/shared/boxGrid/boxGrid';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';

import { bodyshopApi } from '@/main/api';
import { KOGTableRow } from '@/main/components/shared/boxGrid/styles';
import { getTranslateByKey } from '@/main/services/utils';
import { RoutesConstants } from '@/main/routes/routesConstants';

import { useBodyshopRegisterContext } from '../context';
import * as S from './styles';
import * as SP from '../styles';

interface IBranchInfoState {
  id: string;
  name: string;
}
interface IBranchInfoProps {
  guidBodyshopEdit?: string | null;
  clearAddBranch: () => void;
  loadInfoBodyshop: (id: string) => void;
}

function BranchInfo({ guidBodyshopEdit, clearAddBranch, loadInfoBodyshop }: IBranchInfoProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { displaySaveBranchWithHeadquarter } = useBodyshopRegisterContext();
  const { getValues } = useFormContext();
  const [dataBranch, setDataBranch] = useState<IBranchInfoState[]>([]);

  function handleClickBranch(id: string) {
    setSearchParams({ bodyShopGuid: id });
    loadInfoBodyshop(id);
  }

  function handleAddBranch() {
    const rfcHeadquarter = getValues('rfc');
    const countryHeadquarter = getValues('country').key;
    clearAddBranch();

    displaySaveBranchWithHeadquarter(countryHeadquarter, rfcHeadquarter);
  }

  useEffect(() => {
    if (guidBodyshopEdit) {
      bodyshopApi
        .getRegistrationDataBodyshopBranch({ guidBodyShop: guidBodyshopEdit })
        .then(response => {
          const responseBranch = response.data.result;

          if (responseBranch.length > 0) {
            const formattedBranch = responseBranch.map(branch => ({
              id: branch.guid,
              name: branch.companyName
            })) as IBranchInfoState[];
            setDataBranch(formattedBranch);
          }
        });
    }
  }, [guidBodyshopEdit]);

  return (
    <S.Container>
      <SP.HeaderSection>
        <SP.HeaderText>
          {getTranslateByKey('information.branches')}
        </SP.HeaderText>
        <SecondaryButton
          type="button"
          onClick={handleAddBranch}
          style={{ padding: '.2rem .8rem', margin: '0 0 0 1rem' }}
          id="id-registerBodyshop-btn-addBranch">
          {getTranslateByKey('information.addBranch')}
        </SecondaryButton>
      </SP.HeaderSection>

      {dataBranch.length > 0 && (
        <BoxGrid
          rowHeaders={[
            getTranslateByKey('information.bodyshopBranchName'),
            getTranslateByKey('information.actions')
          ]}>
          {dataBranch.map(branch => (
            <KOGTableRow key={branch.id} isSizeLong onClick={() => handleClickBranch(branch.id)}>
              <TableCell width="95%">{branch.name}</TableCell>
              <TableCell width="5%" align="center" id="id-registerBodyshop-icon-magnifyingGlass">
                <Search fontSize="medium" />
              </TableCell>
            </KOGTableRow>
          ))}
        </BoxGrid>
      )}
    </S.Container>
  );
}

export default BranchInfo;
